import { http, HttpResponse, PathParams } from "msw";

import {
  GetDeploymentTeamResponse,
  ListDeploymentTeamsResponse,
  Team,
  TeamRole,
} from "@protos/permissions/v2/permissions";
import { TeamScope } from "@protos/permissions/v2/scopes";

import { generateTeamData } from "./data";

// randomly generated data for fullstory
export const permissionsHandlersGenerated = [
  http.get<PathParams, ListDeploymentTeamsResponse>(
    "*/api/permissions/deployments/:deploymentId/teams",
    ({ request }) => {
      const url = new URL(request.url);
      const parentId = url.searchParams.get("parent_id");
      let id;
      if (parentId === "null") {
        id = null;
      } else {
        id = parseInt(parentId ?? "");
      }
      const { teams } = generateTeamData(id);

      const resp: ListDeploymentTeamsResponse = {
        teams,
      };

      return HttpResponse.json(resp);
    }
  ),
  http.get<PathParams, GetDeploymentTeamResponse>(
    "*/api/permissions/deployments/:deploymentId/teams/:teamId",
    ({ request }) => {
      const url = new URL(request.url);
      const teamId = parseInt(url.searchParams.get("teamId") as string);
      const { team } = generateTeamData(teamId);

      const resp: GetDeploymentTeamResponse = {
        team,
      };
      return HttpResponse.json(resp);
    }
  ),
];

export const TEST_ROOT_TEAMS: Team[] = [
  {
    id: 1,
    name: "Team 1",
    parentTeamId: undefined,
    deploymentId: 1,
    slug: "team-1",
    repositoryIds: [1, 2, 3, 4],
    repositoryCount: 4,
    childTeamIds: [4, 5, 6],
    childTeamCount: 3,
    users: [{ userId: 186, role: TeamRole.MEMBER }],
    userCount: 1,
    authorizedScopes: [TeamScope.DIRECT_MEMBER, TeamScope.MANAGE],
  },
  {
    id: 2,
    name: "Team 2",
    parentTeamId: undefined,
    deploymentId: 1,
    slug: "team-2",
    repositoryIds: [1, 2],
    repositoryCount: 4,
    childTeamIds: [],
    childTeamCount: 0,
    users: [{ userId: 186, role: TeamRole.MEMBER }],
    userCount: 1,
    authorizedScopes: [TeamScope.DIRECT_MEMBER, TeamScope.MANAGE],
  },
  {
    id: 3,
    name: "Empty team",
    parentTeamId: undefined,
    deploymentId: 1,
    slug: "empty-team",
    repositoryIds: [],
    repositoryCount: 0,
    childTeamIds: [],
    childTeamCount: 0,
    users: [],
    userCount: 0,
    authorizedScopes: [TeamScope.MANAGE],
  },
  {
    id: 4,
    name: "Non-member team",
    parentTeamId: undefined,
    deploymentId: 1,
    slug: "non-member-team",
    repositoryIds: [],
    repositoryCount: 0,
    childTeamIds: [],
    childTeamCount: 0,
    users: [],
    userCount: 0,
    authorizedScopes: [],
  },
];

export const permissionsHandlersStatic = [
  http.get("*/api/permissions/deployments/:deploymentId/teams", () =>
    HttpResponse.json({ teams: TEST_ROOT_TEAMS })
  ),
  http.post("*/api/permissions/deployments/:deploymentId/teams*", () => {
    return new HttpResponse(null, { status: 200 });
  }),
  http.patch("*/api/permissions/deployments/:deploymentId/teams*", () => {
    return HttpResponse.json({ team: TEST_ROOT_TEAMS[0] });
  }),
  http.get("*/api/permissions/deployments/:deploymentId/teams/:teamId", () => {
    return HttpResponse.json({ team: TEST_ROOT_TEAMS[0] });
  }),
  http.delete("*/api/permissions/deployments/:deploymentId/teams*", () => {
    return new HttpResponse(null, { status: 200 });
  }),
  http.get("*/api/permissions/deployments/:deploymentId/status", () => {
    return HttpResponse.json({
      deploymentId: 1,
      enabled: true,
      selfServeEnabled: true,
    });
  }),
];
